import { Head, useForm } from '@inertiajs/react'
import { AuthShell } from '@/components/auth/AuthShell'
import { Button, Field, Label, Input, ErrorMessage } from '@/components/ui'
import { useTranslations } from '@/lib/i18n'

interface ResetPasswordProps {
  reset_password_token: string
  errors: Record<string, string>
}

export default function ResetPassword({ reset_password_token, errors }: ResetPasswordProps) {
  const { t } = useTranslations()
  const form = useForm({
    reset_password_token,
    password: '',
    password_confirmation: '',
  })

  function submit(event: React.FormEvent) {
    event.preventDefault()
    form.transform((data) => ({ user: data }))
    form.put('/users/password')
  }

  return (
    <AuthShell title={t('auth.reset_title')} subtitle={t('auth.reset_subtitle')}>
      <Head title={t('auth.reset_title')} />

      <form onSubmit={submit} className="flex flex-col gap-5">
        <Field>
          <Label>{t('auth.new_password')}</Label>
          <Input
            type="password"
            name="password"
            autoComplete="new-password"
            autoFocus
            required
            value={form.data.password}
            onChange={(e) => form.setData('password', e.target.value)}
          />
          {errors.password && <ErrorMessage>{errors.password}</ErrorMessage>}
        </Field>

        <Field>
          <Label>{t('auth.confirm_password')}</Label>
          <Input
            type="password"
            name="password_confirmation"
            autoComplete="new-password"
            required
            value={form.data.password_confirmation}
            onChange={(e) => form.setData('password_confirmation', e.target.value)}
          />
          {errors.password_confirmation && <ErrorMessage>{errors.password_confirmation}</ErrorMessage>}
        </Field>

        <Button type="submit" color="brand" disabled={form.processing} className="w-full">
          {t('auth.update_password')}
        </Button>
      </form>
    </AuthShell>
  )
}
